var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LSSelections } from "@/types/storage";
import { createContext, useContext, useState } from "react";
var defaultElectionEventTallyContext = {
    tallyId: null,
    setTallyId: function () { return undefined; },
    isTrustee: false,
    setCreatingFlag: function () { return undefined; },
    isCreatingType: null,
    setCreatedFlag: function () { return undefined; },
    isCreated: undefined,
    electionEventId: null,
    setElectionEventIdFlag: function () { return undefined; },
    electionId: null,
    setElectionIdFlag: function () { return undefined; },
    contestId: null,
    setContestIdFlag: function () { return undefined; },
    getContestIdFlag: function () { return null; },
    candidateId: null,
    setCandidateIdFlag: function () { return undefined; },
    getCandidateIdFlag: function () { return null; },
    miruAreaId: null,
    setMiruAreaId: function () { return undefined; },
    selectedTallySessionData: null,
    setSelectedTallySessionData: function () { return undefined; },
    taskId: null,
    setTaskId: function () { return undefined; },
    customFilter: {},
    setCustomFilter: function () { return undefined; },
};
export var ElectionEventTallyContext = createContext(defaultElectionEventTallyContext);
export var ElectionEventTallyContextProvider = function (props) {
    var _a = useState(null), tally = _a[0], setTally = _a[1];
    var _b = useState(false), isTrustee = _b[0], setIsTrustee = _b[1];
    var _c = useState(null), isCreatingType = _c[0], setIsCreatingType = _c[1];
    var _d = useState(undefined), isCreated = _d[0], setIsCreated = _d[1];
    var _e = useState(null), task = _e[0], setTask = _e[1];
    var _f = useState(null), miruAreaId = _f[0], setMiruAreaId = _f[1];
    var _g = useState(null), selectedTallySessionData = _g[0], setSelectedTallySessionData = _g[1];
    var _h = useState({}), customFilter = _h[0], SetCustomFilter = _h[1];
    var _j = useState(null), electionEventId = _j[0], setElectionEventId = _j[1];
    var _k = useState(null), electionId = _k[0], setElectionId = _k[1];
    var _l = useState(null), contestId = _l[0], setContestId = _l[1];
    var _m = useState(null), candidateId = _m[0], setCandidateId = _m[1];
    var setTallyId = function (tallyId, isTrustee) {
        setTally(tallyId);
        setIsTrustee(isTrustee || false);
    };
    var setCreatingFlag = function (isCreating) {
        setIsCreatingType(isCreating);
    };
    var setCreatedFlag = function (isCreated) {
        setIsCreated(isCreated);
    };
    var setTaskId = function (value) {
        setTask(value);
    };
    var setCustomFilter = function (filter) {
        SetCustomFilter(filter);
    };
    var setElectionEventIdFlag = function (electionEventId) {
        if (electionEventId) {
            setElectionEventId(electionEventId);
            localStorage.setItem(LSSelections.ELECTION_EVENT, electionEventId);
        }
        else {
            setElectionEventId(null);
            localStorage.removeItem(LSSelections.ELECTION_EVENT);
        }
    };
    var setElectionIdFlag = function (electionId) {
        if (electionId) {
            setElectionId(electionId);
            localStorage.setItem(LSSelections.ELECTION, electionId);
        }
        else {
            setElectionId(null);
            localStorage.removeItem(LSSelections.ELECTION);
        }
    };
    var setContestIdFlag = function (contestId) {
        if (contestId) {
            setContestId(contestId);
            localStorage.setItem(LSSelections.CONTEST, contestId);
        }
        else {
            setContestId(null);
            localStorage.removeItem(LSSelections.CONTEST);
        }
    };
    var setCandidateIdFlag = function (candidateId) {
        if (candidateId) {
            setCandidateId(contestId);
            localStorage.setItem(LSSelections.CANDIDATE, candidateId);
        }
        else {
            setCandidateId(null);
            localStorage.removeItem(LSSelections.CANDIDATE);
        }
    };
    var getContestIdFlag = function () {
        var _a;
        return (_a = localStorage.getItem(LSSelections.CONTEST)) !== null && _a !== void 0 ? _a : null;
    };
    var getCandidateIdFlag = function () {
        var _a;
        return (_a = localStorage.getItem(LSSelections.CANDIDATE)) !== null && _a !== void 0 ? _a : null;
    };
    return (_jsx(ElectionEventTallyContext.Provider, __assign({ value: {
            tallyId: tally,
            setTallyId: setTallyId,
            isTrustee: isTrustee,
            isCreatingType: isCreatingType,
            setCreatingFlag: setCreatingFlag,
            isCreated: isCreated,
            setCreatedFlag: setCreatedFlag,
            electionEventId: electionEventId,
            setElectionEventIdFlag: setElectionEventIdFlag,
            electionId: electionId,
            setElectionIdFlag: setElectionIdFlag,
            contestId: contestId,
            setContestIdFlag: setContestIdFlag,
            getContestIdFlag: getContestIdFlag,
            candidateId: candidateId,
            setCandidateIdFlag: setCandidateIdFlag,
            getCandidateIdFlag: getCandidateIdFlag,
            miruAreaId: miruAreaId,
            setMiruAreaId: setMiruAreaId,
            selectedTallySessionData: selectedTallySessionData,
            setSelectedTallySessionData: setSelectedTallySessionData,
            setTaskId: setTaskId,
            taskId: task,
            customFilter: customFilter,
            setCustomFilter: setCustomFilter,
        } }, { children: props.children })));
};
export var useElectionEventTallyStore = function () {
    var _a = useContext(ElectionEventTallyContext), tallyId = _a.tallyId, setTallyId = _a.setTallyId, isTrustee = _a.isTrustee, isCreatingType = _a.isCreatingType, setCreatingFlag = _a.setCreatingFlag, isCreated = _a.isCreated, setCreatedFlag = _a.setCreatedFlag, electionEventId = _a.electionEventId, setElectionEventIdFlag = _a.setElectionEventIdFlag, electionId = _a.electionId, setElectionIdFlag = _a.setElectionIdFlag, contestId = _a.contestId, setContestIdFlag = _a.setContestIdFlag, getContestIdFlag = _a.getContestIdFlag, candidateId = _a.candidateId, setCandidateIdFlag = _a.setCandidateIdFlag, getCandidateIdFlag = _a.getCandidateIdFlag, miruAreaId = _a.miruAreaId, setMiruAreaId = _a.setMiruAreaId, selectedTallySessionData = _a.selectedTallySessionData, setSelectedTallySessionData = _a.setSelectedTallySessionData, taskId = _a.taskId, setTaskId = _a.setTaskId, customFilter = _a.customFilter, setCustomFilter = _a.setCustomFilter;
    return {
        tallyId: tallyId,
        setTallyId: setTallyId,
        isTrustee: isTrustee,
        creatingType: isCreatingType,
        setCreatingFlag: setCreatingFlag,
        isCreated: isCreated,
        setCreatedFlag: setCreatedFlag,
        electionEventId: electionEventId,
        setElectionEventIdFlag: setElectionEventIdFlag,
        electionId: electionId,
        setElectionIdFlag: setElectionIdFlag,
        contestId: contestId,
        setContestIdFlag: setContestIdFlag,
        getContestIdFlag: getContestIdFlag,
        candidateId: candidateId,
        setCandidateIdFlag: setCandidateIdFlag,
        getCandidateIdFlag: getCandidateIdFlag,
        miruAreaId: miruAreaId,
        setMiruAreaId: setMiruAreaId,
        selectedTallySessionData: selectedTallySessionData,
        setSelectedTallySessionData: setSelectedTallySessionData,
        taskId: taskId,
        setTaskId: setTaskId,
        customFilter: customFilter,
        setCustomFilter: setCustomFilter,
    };
};
